import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const PROJECTS = [
  { label: 'Herba', to: '/work/herba' },
  { label: 'Culture Amp', to: '/work/culture-amp' },
  { label: 'Disco', to: '/work/disco' },
  { label: 'Flok', to: '/work/flok' },
  { label: 'WhoSay', to: '/work/whosay' },
];

// Navigation shown on every case study page:
// - Desktop: a sticky close button in the top right that returns to the
//   homepage. The homepage restores the visitor's earlier scroll position
//   (saved when they opened the case study), so they land where they were.
// - Mobile: a sticky top bar with a menu for moving between projects.
const CaseStudyNav = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const go = (to) => {
    setIsMenuOpen(false);
    navigate(to);
  };

  return (
    <>
      {/* Desktop close button */}
      <button
        onClick={() => navigate('/')}
        aria-label="Close case study and return to the homepage"
        className="hidden lg:flex fixed top-6 right-6 z-50 h-11 w-11 items-center justify-center rounded-full bg-gray-200/90 text-black backdrop-blur transition-colors duration-200 hover:bg-gray-300 focus:outline-none focus-visible:ring-2 focus-visible:ring-black focus-visible:ring-offset-2"
      >
        <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>

      {/* Mobile sticky nav */}
      <nav className={`lg:hidden fixed top-0 left-0 right-0 z-40 bg-white/85 backdrop-blur-xl border-b border-black/5 transition-shadow duration-300 ${isMenuOpen ? 'shadow-[0_16px_32px_-8px_rgba(0,0,0,0.22)]' : ''}`}>
        <div className="px-5 py-3">
          <div className="flex items-center justify-between">
            <button onClick={() => go('/')} className="text-[15px] font-bold tracking-tight text-ink">
              Kacey Fillingim
            </button>
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="p-2 -mr-2 rounded-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-ink"
              aria-label={isMenuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={isMenuOpen}
            >
              <svg className="w-6 h-6 text-ink" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.75} d="M4 8h16M4 16h16" />
                )}
              </svg>
            </button>
          </div>
          {isMenuOpen && (
            <ul className="mt-3 pb-3 space-y-1">
              <li>
                <button
                  onClick={() => go('/')}
                  className="w-full text-left px-3 py-2.5 rounded-xl text-[17px] text-muted hover:bg-canvas hover:text-ink transition-colors duration-200"
                >
                  Home
                </button>
              </li>
              {PROJECTS.map(({ label, to }) => (
                <li key={to}>
                  <button
                    onClick={() => go(to)}
                    aria-current={pathname === to ? 'page' : undefined}
                    className={`w-full text-left px-3 py-2.5 rounded-xl text-[17px] transition-colors duration-200 ${
                      pathname === to ? 'bg-canvas text-ink font-semibold' : 'text-muted hover:bg-canvas hover:text-ink'
                    }`}
                  >
                    {label}
                  </button>
                </li>
              ))}
              <li className="pt-3">
                <button
                  onClick={() => go('/#contact-form')}
                  className="w-full rounded-full bg-ink px-5 py-3 text-[17px] font-medium text-white transition-colors duration-200 hover:bg-black"
                >
                  Contact
                </button>
              </li>
            </ul>
          )}
        </div>
      </nav>
    </>
  );
};

export default CaseStudyNav;
